import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
@Component({
  selector: 'app-new-enterprise',
  templateUrl: './new-enterprise.component.html',
  styleUrls: ['./new-enterprise.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
    , MatInputModule
    , MatFormFieldModule
    , MatIconModule
    , CommonModule
    , MatButtonModule
  ]
})
export class NewEnterpriseComponent{
  loading = false;
  hide: boolean = false;
  form: UntypedFormGroup = new UntypedFormGroup({
    user: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required]),
    clientID: new UntypedFormControl('', [Validators.required]),
  })
  constructor(
    @Inject(MAT_DIALOG_DATA) public token: string,
    public appStateService: AppStateService,
    private dialogRef: MatDialogRef<NewEnterpriseComponent>   
  ) {
    this.form.markAllAsTouched();
  }

  onSubmit() {
    this.loading = true;
    const { value } = this.form;
    this.appStateService.AccountService.CreateEnterprise(value, this.token)
    .subscribe(({success}) =>{
      this.loading = false;
      if(success){
        this.onClose({ action: true })
      }
    },
    err =>{
      this.loading = false;
    });
  } 
  onClose = (data?: { [key: string]: any }) => this.dialogRef.close({...data})
}
